import Promise from "es6-promise";

/**
 * Debounces a function
 *
 * @param {int} timeout
 * @param {Function} callback
 * @returns {Function}
 */
export function debounce(timeout, callback) {
    var timer;

    return function () {
        var args = arguments;

        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        timer = setTimeout(() => {
            timer = null;
            callback.apply(this, args);

        }, timeout);
    };
}

/**
 * Generates a unique id
 * @param prefix
 */

export function uuid(prefix = "") {
    var chars = '0123456789abcdef'.split('');

    var uuid = [], rnd = Math.random, r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    for (var i = 0; i < 36; i++) {
        if (!uuid[i]) {
            r = 0 | rnd() * 16;

            uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r & 0xf];
        }
    }

    return prefix + uuid.join('');
}

/**
 * Queues a set of tasks which return promises
 * @returns {Promise}
 */
export function queue(/* fn ... */) {
    var tasks = Array.prototype.slice.call(arguments);

    return new Promise((resolve, reject) => {
        // Next task function
        function next() {
            if (tasks.length === 0) {
                return resolve();
            }

            return tasks.shift().call().then(next).catch(reject);
        }

        // Start
        next();
    });
}